<template>
  <div>
    <VBusHelper
      :reactOn="$constants.EVENTS.RESTAURANT.SHOW_RESTAURANT_DETAIL"
      :handler="showDetails"
    />

  <VBusHelper
    :reactOn="$constants.EVENTS.ORDERS.CREATED"
    :handler="closeDialog"
  />
  <VBusHelper
    :reactOn="$constants.EVENTS.RESTAURANT.RATED"
    :handler="refreshDetails"
  />
  <VBusHelper
    :reactOn="$constants.EVENTS.USER.FAVORITE_SUCCESS"
    :handler="refreshDetails"
  />
    <DialogComponent
      ref="dialog"
      type="fullscreen"
      noInnerPadding
      hideCloseButton
    >
      <RestaurantDetail
        v-if="restaurantData && !isLoading"
        :restaurantData="restaurantData"
        :dishesData="dishesData"
        @close="() => $refs.dialog.hide()"
      />
      <!-- Shimmer loading state -->
      <div v-else class="h-full flex flex-col bg-white">
        <div class="mobile-margin-top py-4 px-6">
          <div class="w-9 h-9 rounded-full shimmerElementRoundedDefault"></div>
        </div>
        <div
          class="w-full py-[35%] relative shimmerElementRoundedDefault"
        ></div>
        <div class="bg-white rounded-t-3xl py-8 -mb-8 -mt-8 relative"></div>
        <div class="relative bg-white px-6">
          <div class="h-8 w-3/4 shimmerElement rounded-xl mb-4"></div>
          <div class="h-6 w-1/2 shimmerElement rounded-xl mb-2"></div>
          <div class="h-6 w-1/3 shimmerElement rounded-xl"></div>
        </div>
      </div>
    </DialogComponent>
  </div>
</template>

<script setup>
import { ref, getCurrentInstance } from 'vue';
import RestaurantDetail from './RestaurantDetail.vue';

const dialog = ref(null);
const restaurantData = ref(null);
const dishesData = ref([]);
const isLoading = ref(false);
const { proxy } = getCurrentInstance();
const { $constants, $bus } = proxy;

const closeDialog = () => {
  dialog.value.hide();
};

const refreshDetails = () => {
  if (!restaurantData.value?.id) return;
  const currentId = restaurantData.value.id;
  
  const onRefreshLoaded = (restaurant) => {
    const newRest = restaurant?.restaurant || restaurant;
    if (newRest && newRest.id === currentId) {
      restaurantData.value = newRest;
      $bus.off($constants.EVENTS.RESTAURANT.RESTAURANT_DETAIL_LOADED, onRefreshLoaded);
    }
  };
  
  $bus.on($constants.EVENTS.RESTAURANT.RESTAURANT_DETAIL_LOADED, onRefreshLoaded);
  $bus.emit($constants.EVENTS.RESTAURANT.RESTAURANT_DETAILS_REQUESTED, { id: currentId });
};
const showDetails = async (payload) => {
  if (!payload?.id) return;
  dialog.value.show();

  // Reset state
  restaurantData.value = null;
  dishesData.value = [];
  isLoading.value = true;

  // Cleanup previous listeners if any
  const cleanup = () => {
    $bus.off($constants.EVENTS.RESTAURANT.RESTAURANT_DETAIL_LOADED, onRestaurantLoaded);
    $bus.off($constants.EVENTS.RESTAURANT.DISHES_LOADED, onDishesLoaded);
    $bus.off($constants.EVENTS.RESTAURANT.RESTAURANT_DETAIL_ERROR, onError);
    // $bus.off($constants.EVENTS.RESTAURANT.DISHES_ERROR, onError);
  };

  const onRestaurantLoaded = (restaurant) => {
    // Handle both combined object (old controller) and direct object (new controller)
    restaurantData.value = restaurant?.restaurant || restaurant;
    if (restaurant?.dishes) dishesData.value = restaurant.dishes;
    
    isLoading.value = false;
    $bus.off($constants.EVENTS.RESTAURANT.RESTAURANT_DETAIL_LOADED, onRestaurantLoaded);
  };

  const onDishesLoaded = (dishes) => {
    dishesData.value = dishes || [];
    $bus.off($constants.EVENTS.RESTAURANT.DISHES_LOADED, onDishesLoaded);
  };

  const onError = (error) => {
    console.error('Failed to load restaurant:', error);
    isLoading.value = false;
    cleanup();
    dialog.value.hide();
  };

  cleanup(); // Clean up before starting new request

  $bus.on($constants.EVENTS.RESTAURANT.RESTAURANT_DETAIL_LOADED, onRestaurantLoaded);
  $bus.on($constants.EVENTS.RESTAURANT.DISHES_LOADED, onDishesLoaded);
  $bus.on($constants.EVENTS.RESTAURANT.RESTAURANT_DETAIL_ERROR, onError);
  // $bus.on($constants.EVENTS.RESTAURANT.DISHES_ERROR, onError);

  // Trigger the API calls
  $bus.emit($constants.EVENTS.RESTAURANT.RESTAURANT_DETAILS_REQUESTED, { id: payload.id });
  $bus.emit($constants.EVENTS.RESTAURANT.DISHES_REQUESTED, { storeId: payload.id });
};
</script>
